import { FC } from "react";
import { Link, LinkProps } from "expo-router";

import { useTranslate } from "@/hooks/useTranslate";
import { I18nKeyType } from "@/i18n";

import { VnBox } from "./VnBox";
import { VnButton, VnButtonPropsType } from "./VnButton/VnButton";
import { VnText } from "./VnText/VnText";
import { VnTouchableOpacity } from "./VnTouchableOpacity";

type VnLinkPropsType = LinkProps & {
  text?: string;
  i18nKey?: I18nKeyType;
  i18nOptions?: object;
  isDisabled?: boolean;
  renderAsButton?: boolean;
  buttonProps?: Partial<VnButtonPropsType>;
};

export const VnLink: FC<VnLinkPropsType> = ({
  i18nKey,
  i18nOptions,
  text,
  children,
  className,
  isDisabled,
  renderAsButton = false,
  buttonProps,
  ...props
}) => {
  const i18nText = useTranslate(i18nKey, i18nOptions);

  if (renderAsButton) {
    const resolvedI18nKey = buttonProps?.i18nKey ?? i18nKey;
    const resolvedI18nOptions = buttonProps?.i18nOptions ?? i18nOptions;

    if (isDisabled) {
      return (
        <VnButton
          {...buttonProps}
          i18nKey={resolvedI18nKey}
          i18nOptions={resolvedI18nOptions}
          className={className}
          isDisabled>
          {children ?? <VnText>{text ?? i18nText}</VnText>}
        </VnButton>
      );
    }

    return (
      <Link push {...props} asChild>
        <VnButton
          {...buttonProps}
          i18nKey={resolvedI18nKey}
          i18nOptions={resolvedI18nOptions}
          className={className}>
          {children ?? <VnText>{text ?? i18nText}</VnText>}
        </VnButton>
      </Link>
    );
  }

  if (isDisabled) {
    return (
      <VnBox className={className} pointerEvents="none">
        {children ?? <VnText>{text ?? i18nText}</VnText>}
      </VnBox>
    );
  }

  return (
    <Link push {...props} asChild>
      <VnTouchableOpacity className={className}>
        {children ?? <VnText>{text ?? i18nText}</VnText>}
      </VnTouchableOpacity>
    </Link>
  );
};
